import {
  brandSpecific,
  BrandSpecific,
  LocaleSpecific,
  localeSpecific,
} from 'utils/override';
import { useClientContext } from '$/modules/context/client';

type ArrayElementType<T> = T extends (infer U)[] ? U[] : T;

export function useLocaleSpecificClient<T>(
  template: LocaleSpecific<T> | LocaleSpecific<T>[],
): ArrayElementType<T> {
  const { lang } = useClientContext();
  if (Array.isArray(template)) {
    return template.map((item) =>
      localeSpecific(item).get(lang),
    ) as ArrayElementType<T>;
  } else {
    return localeSpecific(template).get(lang) as ArrayElementType<T>;
  }
}

export function useBrandSpecificClient<T>(template: BrandSpecific<T>): T {
  const { brand } = useClientContext();
  return brandSpecific(template).get(brand);
}
